import CarSearchForm from "./CarSearchForm";

export const SearchBar = () => {
    return (
        <>
            <CarSearchForm />
        </>
    );
};
